<!-- eslint-disable max-len -->
<template>
  <div class="border p-2">
    <b-form-group>
      <b-form-checkbox-group v-model="value" text-field='name' value-field='id' style="column-count:2" :options="schema.values" stacked/>
    </b-form-group>
  </div>
</template>

<script>
import { abstractField } from 'vue-form-generator';

export default {
  mixins: [abstractField],
  props: {
    model: {
      type: Object,
    },
    schema: {
      type: Object,
    },
  },
};
</script>
